import React from 'react';
import { FiCalendar, FiClock, FiLoader, FiPlus, FiUsers, FiTrendingUp } from 'react-icons/fi';
import classNames from 'classnames/bind';

import styles from './Exams.module.scss';

const cx = classNames.bind(styles);

const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
};

const formatDuration = (seconds) => {
    if (!Number.isFinite(seconds) || seconds <= 0) {
        return 'Khong xac dinh';
    }

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
        return `${minutes} phut`;
    }

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    if (remainingMinutes === 0) {
        return `${hours} gio`;
    }
    return `${hours} gio ${remainingMinutes} phut`;
};



function ExamGrid({ exams, isLoading, onOpenCreate, onSelectExam}) {
    
    const canOpenCreate = typeof onOpenCreate === 'function';
    const handleOpenCreate = () => {
        if (canOpenCreate) {
            onOpenCreate();
        }
    };

    const renderHeader = () => (
        <div className={cx('card-grid__header')}>
            <div className={cx('card-grid__title')}>
                <h2>Danh sách đề thi</h2>
                <p>Theo dõi tiến độ phát bài thi và nộp bài.</p>
            </div>
            <div className={cx('card-grid__actions')}>
                <button
                    type="button"
                    className={cx('create-button')}
                    onClick={handleOpenCreate}
                    disabled={!canOpenCreate}
                >
                    <FiPlus size={16} />
                    Tạo đề thi
                </button>
            </div>
        </div>
    );

    if (isLoading) {
        return (
            <section className={cx('card-grid')}>
                {renderHeader()}
                <div className={cx('loading-state')}>
                    <FiLoader className={cx('spin')} />
                    Đang tải dữ liệu...
                </div>
            </section>
        );
    }

    if (!Array.isArray(exams) || exams.length === 0) {
        return (
            <section className={cx('card-grid')}>
                {renderHeader(0)}
                <div className={cx('empty-state')}>
                    <h3>Chưa có đề thi nào</h3>
                    <p>Hãy tạo mới và phát đề thi.</p>
                </div>
            </section>
        );
    }

    return (
        <section className={cx('card-grid')}>
            {renderHeader(exams.length)}

            <div className={cx('exams-grid')}>
                {exams.map((exam) => {
                    const submittedUsers = toNumber(exam?.submittedUsers);
                    const totalUsers = toNumber(exam?.totalUsers);
                    const completionRate = totalUsers === 0 ? 0 : Math.round((submittedUsers / totalUsers) * 100);
                    return (
                        <article key={exam.id ?? exam._id} className={cx('exam-card')}
                            onClick={() => onSelectExam && onSelectExam(exam)}
                        >
                            <header className={cx('exam-card__header')}>
                                <h3>{exam.title ?? 'Không rõ tên'}</h3>
                            </header>

                            <div className={cx('exam-card__metrics')}>
                                <div className={cx('exam-card__metric')}>
                                    <span className={cx('exam-card__metric-icon')}>
                                        <FiClock size={16} />
                                    </span>
                                    <div>
                                        <span className={cx('exam-card__metric-label')}>Thời lượng</span>
                                        <strong className={cx('exam-card__metric-value')}>
                                            {formatDuration(toNumber(exam?.duration_seconds))}
                                        </strong>
                                    </div>
                                </div>
                                <div className={cx('exam-card__metric')}>
                                    <span className={cx('exam-card__metric-icon')}>
                                        <FiUsers size={16} />
                                    </span>
                                    <div>
                                        <span className={cx('exam-card__metric-label')}>Đã nộp</span>
                                        <strong className={cx('exam-card__metric-value')}>
                                            {submittedUsers}/{totalUsers}
                                        </strong>
                                    </div>
                                </div>
                                <div className={cx('exam-card__metric')}>
                                    <span className={cx('exam-card__metric-icon')}>
                                        <FiTrendingUp size={16} />
                                    </span>
                                    <div>
                                        <span className={cx('exam-card__metric-label')}>Tỷ lệ hoàn thành</span>
                                        <strong className={cx('exam-card__metric-value')}>{completionRate}%</strong>
                                    </div>
                                </div>
                            </div>
                        </article>
                    );
                })}
            </div>
        </section>
    );
}

export default ExamGrid;
